// extracted by mini-css-extract-plugin
export default {"button":"raisedbutton_button__b+Uq0","text":"raisedbutton_text__juvnp"};